module.exports = __webpack_public_path__ + "static/img/dam.d3f0839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/address/dam.jpg
// module id = pZAR
// module chunks = 0